import { t } from './i18n.js';

const environment = import.meta.env.VITE_ENV.toLowerCase();

const PODS = [

    { id: "napoli", image: import.meta.env.VITE_SCOPE + "images/img/pods/napoli.webp", label: t("napoli")     },
    { id: "kazaar", image: import.meta.env.VITE_SCOPE + "images/img/pods/kazaar.webp", label: t("kazaar")     },
    { id: "ristretto", image: import.meta.env.VITE_SCOPE + "images/img/pods/ristretto.webp", label: t("ristretto")     },
    { id: "arpeggio-deca", image: import.meta.env.VITE_SCOPE + "images/img/pods/arp-deca.avif", label: t("arpeggio-deca")     },
    { id: "nicaragua", image: import.meta.env.VITE_SCOPE + "images/img/pods/nicaragua.png", label: t("nicaragua")     },
    { id: "rio", image: import.meta.env.VITE_SCOPE + "images/img/pods/rio.webp", label: t("rio")     },
    { id: "roma", image: import.meta.env.VITE_SCOPE + "images/img/pods/roma.webp", label: t("roma")     },
    { id: "paris", image: import.meta.env.VITE_SCOPE + "images/img/pods/paris.webp", label: t("paris")     },
    { id: "hawaii", image: import.meta.env.VITE_SCOPE + "images/img/pods/hawaii.avif", label: t("hawaii")     },
    { id: "buenosaires", image: import.meta.env.VITE_SCOPE + "images/img/pods/buenosaires-lungo.webp", label: t("buenosaires")     },
];

if (environment == "dev") {
    PODS.push({ id: "apple", image: import.meta.env.VITE_SCOPE + "images/img/pods/apple.webp", label: t("apple")     });
    PODS.push({ id: "sprite", image: import.meta.env.VITE_SCOPE + "images/img/pods/sprite.avif", label: t("sprite")     });
}

function getPods() {
    return PODS;
}

function getPodImage(id) {
    const idx = PODS.findIndex(e => e.id === id);
    return PODS[idx >= 0 ? idx : 0].image;
}

export { getPods, getPodImage }